export const NAVBAR = "NAVBAR";
export const TOGGLE = "TOGGLE";
export const B2T = "B2T";
export const NEXT = "NEXT";
export const AUTH = "AUTH";
export const CAMPUS = 'CAMPUS';
